import global from 'global';
import { assign, identity, isPlainObject, isFunction, each } from 'lodash';
import { parse } from 'content-type';
import { CONTENT_TYPE } from 'http-header-fields';

const isFormData = type => type && parse(type).type === 'multipart/form-data';
const toFormData = (object) => {
  const data = new global.FormData();
  each(object, (value, name) => data.append(name, value));

  return data;
};

export default () => ({ options }) => {
  if (!isFunction(global.FormData)) {
    return identity;
  }

  if (isFormData(options.headers[CONTENT_TYPE]) && isPlainObject(options.body)) {
    assign(options, {
      body: toFormData(options.body),
    });
  }

  return identity;
};



// WEBPACK FOOTER //
// ./src/Api/middleware/formData.js